'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface BalanceDisplayState {
  /** Whether to include the USDC value of outcome token holdings in the displayed balance. */
  includeHoldings: boolean;
  setIncludeHoldings: (value: boolean) => void;
}

/**
 * UI preference store for whether displayed balances include the value of
 * the user's outcome token holdings (in addition to their USDC balance).
 *
 * Default: true (combined view). Persisted to localStorage so it survives reload.
 */
export const useBalanceDisplayStore: UseBoundStore<StoreApi<BalanceDisplayState>> =
  createTrackedStore<BalanceDisplayState>('useBalanceDisplayStore')(
    persist(
      (set) => ({
        includeHoldings: true,
        setIncludeHoldings: (value: boolean): void => {
          set({ includeHoldings: value });
        },
      }),
      {
        name: 'morfi-balance-display',
      },
    ),
  );
